export function buPrefix(buName?: string) {
	return buName ? `Hypera - ${buName}` : '';
}

export function handleFormatDistributorName(summarizedCorporateName: string, commercialCenter: string) {
	return `${summarizedCorporateName} (${commercialCenter.toUpperCase()})`;
}
